import { extract } from '../extractors/verdict';

const txt = (lang, zh, en) => (lang === 'en' ? en : zh);

export function buildHtml(project, a, lang = 'zh') {
  const v = extract(project, a, lang);
  if (!v) return '';
  const redList   = v.triggeredRed.slice(0, 6);
  const greenList = v.triggeredGreen.slice(0, 6);
  return `
<div style="border:1px solid #e5e7eb;border-left:4px solid ${v.color};background:${v.bg};border-radius:10px;overflow:hidden;margin-bottom:14px">
  <div style="padding:14px 16px">
    <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:10px">
      <div>
        <div style="font-size:10px;font-weight:700;color:#6b7280;text-transform:uppercase;margin-bottom:4px">
          💡 ${txt(lang, '投资建议（综合判断）', 'Investment Verdict')}
        </div>
        <div style="font-size:22px;font-weight:900;color:${v.color};line-height:1.2">
          ${lang === 'en' ? v.finalVerdictEn : v.finalVerdict}
        </div>
        ${(v.downgraded || v.upgraded) ? `
          <div style="font-size:10px;color:#6b7280;margin-top:3px">
            ${txt(lang, '基础评级：', 'Base rating:')}
            <span style="text-decoration:line-through;margin-left:4px">${lang === 'en' ? v.baseVerdictEn : v.baseVerdict}</span>
            <span style="margin-left:6px;color:${v.downgraded ? '#dc2626' : '#059669'}">${v.downgraded ? (lang === 'en' ? '↓ downgraded' : '↓ 降级') : (lang === 'en' ? '↑ upgraded' : '↑ 升级')}</span>
          </div>` : ''}
      </div>
    </div>
    ${redList.length > 0 ? `
      <div style="margin-bottom:8px">
        <div style="font-size:10px;font-weight:700;color:#dc2626;margin-bottom:4px">🔴 ${txt(lang, '风险信号', 'Risk Factors')}</div>
        ${redList.map(f => `<div style="font-size:11px;color:#7f1d1d;padding-left:8px;line-height:1.6">• ${lang === 'en' ? f.en : f.zh}</div>`).join('')}
      </div>` : ''}
    ${greenList.length > 0 ? `
      <div style="margin-bottom:8px">
        <div style="font-size:10px;font-weight:700;color:#059669;margin-bottom:4px">🟢 ${txt(lang, '正面信号', 'Positive Factors')}</div>
        ${greenList.map(f => `<div style="font-size:11px;color:#064e3b;padding-left:8px;line-height:1.6">• ${lang === 'en' ? f.en : f.zh}</div>`).join('')}
      </div>` : ''}
    ${v.actionGuide.length > 0 ? `
      <div style="margin-top:10px;padding:8px 10px;background:rgba(255,255,255,0.6);border-radius:6px">
        <div style="font-size:10px;font-weight:700;color:#374151;margin-bottom:4px">📌 ${txt(lang, '操作要点', 'Action Guide')}</div>
        ${v.actionGuide.map(g => `<div style="font-size:11px;color:#1f2937;padding-left:8px;line-height:1.6">• ${g}</div>`).join('')}
      </div>` : ''}
  </div>
</div>`;
}
